import { isNil } from 'lodash/fp';

import { TooltippedSpan } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { MAX_ASIDE_CELL_NAME_LENGTH } from '../../../constants';
import { AsideCellLabelElement } from '../styles';
import { TruncatedEntityName } from './TruncatedEntityName';

interface Props {
    bold?: boolean;
    borderBottom?: boolean;
    borderLeft?: boolean;
    defaultLabelTextKey: string;
    labelVariants?: {
        name: string;
        shortName?: string;
    };
}

const AsideCellLabel = ({ bold, borderBottom, defaultLabelTextKey, labelVariants, ...matrixCellProps }: Props) => (
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    <AsideCellLabelElement bold={bold} borderBottom={borderBottom} {...matrixCellProps} itemAlignment="center">
        {isNil(labelVariants) ? (
            // @ts-expect-error $TSFixMeError: No overload matches this call.
            <LocalizedText textKey={defaultLabelTextKey} />
        ) : (
            <TooltippedSpan tooltip={labelVariants.name}>
                <TruncatedEntityName maxNameLength={MAX_ASIDE_CELL_NAME_LENGTH} {...labelVariants} />
            </TooltippedSpan>
        )}
    </AsideCellLabelElement>
);

export default AsideCellLabel;
